export enum TimeOfDaySpecifier {
  LATE = 'late',
  EARLY = 'early',
}
